import ToggleablePanel from './ToggleablePanel.jsx';
import { useState } from 'react';
import { SlidingPanelPage } from '../SlidingSidePanel.jsx';
import FileUpload from '../FileUpload';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import UploadSquareIcon from '../icons/UploadSquareIcon.jsx';
import Loading from '../Loading';
import { TrashIcon } from '@heroicons/react/24/outline';

const UploadLogo = ({ children, setStyles, styles, objectId, objectType }) => {
    const { save, isSaving } = useBusinessPostApi(`/forms/${objectType}/${objectId}/logo`);

    function saveLogo(newLogo) {
        save({
            upload: newLogo,
        }).then(result => {
            const newStyles = {
                ...styles,
                logo: result,
            };

            setStyles(newStyles);
        });
    }

    function removeLogo() {
        saveLogo('');
    }

    const logoUrl = `/forms/${objectType}/${objectId}/logo?${styles.logo}`;

    return (
        <label className="cursor-pointer">
            {children}
            {!children && (
                <div>
                    <div className="p-6 bg-gray-200 rounded-lg">
                        {!!styles.logo && (
                            <div className="flex items-center justify-between">
                                <img
                                    src={logoUrl}
                                    alt="Logo"
                                    className="max-w-32 max-h-24"
                                />
                                <button
                                    type="button"
                                    className="text-red-600"
                                    onClick={removeLogo}
                                >
                                    <TrashIcon className="w-5 h-5" />
                                </button>
                            </div>
                        )}
                        {!styles.logo && (
                            <div className="text-gray-500">
                                There is no logo set
                            </div>
                        )}
                    </div>

                    <span className="btn-light-pill cursor-pointer inline-block mt-1">
                        {!!styles.logo ? 'Upload New' : 'Upload'}
                    </span>
                </div>
            )}
            <FileUpload
                onChange={saveLogo}
                className="hidden"
                id="logo"
                accept="image/*"
            />
            {isSaving && <Loading />}
        </label>
    );
};

const StylesHeaderLogo = ({ objectId, objectType, styles, setStyles }) => {
    const [showPanel, setShowPanel] = useState(false);

    const hasLogo = !!styles.logo;
    const logoUrl = `/forms/${objectType}/${objectId}/logo?${styles.logo}`;

    return (
        <div className="mt-4">
            <div className="panel-label">Logo</div>
            <ToggleablePanel
                enabled={!!styles?.logo && !styles?.logoDisabled}
                setEnabled={newValue =>
                    setStyles({ ...styles, logoDisabled: !newValue })
                }
                onClick={() => hasLogo && setShowPanel(true)}
                hideToggle={!hasLogo}
                hideCog={!hasLogo}
            >
                {hasLogo && (
                    <img
                        src={logoUrl}
                        alt="Logo"
                        className="max-w-32 max-h-24"
                    />
                )}
                {!hasLogo && (
                    <UploadLogo
                        styles={styles}
                        setStyles={setStyles}
                        objectId={objectId}
                        objectType={objectType}
                    >
                        <div className="text-primary-700 flex items-center">
                            <UploadSquareIcon className="w-5 h-5 mr-2" />
                            Upload a logo
                        </div>
                    </UploadLogo>
                )}
            </ToggleablePanel>
            <SlidingPanelPage
                isOpen={showPanel}
                onClose={() => setShowPanel(false)}
                title="Logo"
            >
                <div className="input-label">Logo</div>
                <UploadLogo
                    styles={styles}
                    setStyles={setStyles}
                    objectId={objectId}
                    objectType={objectType}
                    showDelete={true}
                />

                {!!styles.logo && (
                    <>
                        <div className="panel-label mt-6">Shadow</div>
                        <ToggleablePanel
                            enabled={styles?.logoShadow}
                            setEnabled={newValue =>
                                setStyles({ ...styles, logoShadow: newValue })
                            }
                        >
                            <div className="text-gray-500 text-sm">
                                Show box shadow around logo
                            </div>
                        </ToggleablePanel>
                    </>
                )}
            </SlidingPanelPage>
        </div>
    );
};

export default StylesHeaderLogo;
